import Vue from "vue";
export let settings;

export async function loadAppSettings() {
  settings = { serverUrl: null, googleClientId: null };
  try {
    const d = new Date();
    const timestamp = d.getTime();
    if (process.env.NODE_ENV === "development") {
      console.log("Loading development settings");
      try {
        let response = await Vue.axios.get(
          `/appsettings.Development.json?t=${timestamp}`
        );
        if (response && response.status === 200) {
          settings.serverUrl = response.data && response.data.serverUrl;
          settings.googleClientId =
            response.data && response.data.googleClientId;
        }
      } catch {
        console.warn("no appsettings.Development.json found");
      }
      if (!settings.serverUrl)
        settings.serverUrl = "http://" + window.location.hostname + ":5100";
    } else {
      try {
        let response = await Vue.axios.get(
          `/appsettings.Production.json?t=${timestamp}`
        );
        settings = response.data;
      } catch {
        let response = await Vue.axios.get(`/appsettings.json?t=${timestamp}`);
        settings = response.data;
      }
    }
    settings.timeStamp = timestamp;
  } catch (err) {
    console.error(err);
  }
}
export const optionAxios = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};
